export const FILTER_TYPES = {
  ALL: 'All',
  ACTIVE: 'Active',
  DONE: 'Done',
  IMPORTANT: 'Important',
} as const;
